module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/hoodie/3-8a68bd7f8223045f49e39b98ad4e32b0.jpg";